import React from "react";
import { ReportFormat } from "@common/helpers/reports";
import { DownloadIcon } from "@icons";
import { Loader } from "@design-system/Loader/Loader";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";

interface DownloadDropdownProps {
    onDownload: (format: ReportFormat) => void;
    disabled: boolean;
    loading: boolean;
    pdfDisabled?: boolean;
    pdfDisabledTooltip?: string;
}

export const DownloadDropdown: React.FC<DownloadDropdownProps> = ({
    onDownload,
    disabled,
    loading,
    pdfDisabled,
    pdfDisabledTooltip,
}) => (
    <Menu.Root
        disabled={disabled || loading}
        trigger={
            <Button
                type="button"
                variant="primary"
                size="md"
                iconOnly
                aria-label="Download report"
            >
                {loading ? <Loader inline /> : <DownloadIcon />}
            </Button>
        }
    >
        <Menu.Item onClick={() => onDownload(ReportFormat.XLSX)}>
            .xlsx
        </Menu.Item>
        <Menu.Item
            disabled={pdfDisabled}
            disabledReason={pdfDisabledTooltip}
            onClick={() => onDownload(ReportFormat.PDF)}
        >
            .pdf
        </Menu.Item>
    </Menu.Root>
);
